import React from 'react'
import Layout from '../Layout'
import PostAuctio from '../../../utils/CommonFunctionality/PostAuction'
const PostAuction = (props) => {
    return (
        <>
            <Layout props={props}>
                <div className="postProductContainer">
                    <PostAuctio defaultCountryCode={224} />
                </div>
            </Layout>
        </>
    )
}

export default PostAuction
